// src/Loan/LoanCard.jsx
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { data, useLocation, useParams } from "react-router-dom";
import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
import jsPDF from "jspdf";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanCard.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// Utils
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};
const formatAmount = (amount) =>
  !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

const LoanCard = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const cardRef = useRef();
  const location = useLocation();
  const currentuserid= location.state?.loan;
  // console.log("currenet user id",currentuserid);

  const { emis, loading: emiLoading, error: emiError } = useSelector(
    (state) => state.loanEmi
  );

  // console.log(emis);
  const { loans, loading: loanLoading, error: loanError } = useSelector(
    (state) => state.loanReport
  );
  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [customerDetails,setCustomerDetails]=useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  // ✅ Fetch Profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ✅ Fetch Loan + Company
  useEffect(() => {


    if (loanId) {
      dispatch(fetchLoanEmis(loanId));
      if (loans.length === 0) dispatch(fetchAllLoans());
    }

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          if(data.qrCodeImage){
            data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    if (profile?.superAdminId) fetchCompany();

    return () => dispatch(clearLoanEmis());
  }, [dispatch, loanId, loans.length, profile?.superAdminId]);

  const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
  const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";
  // const branchId=emis?.[0]?.branchId || 0;

  // ✅ Fetch Customer Photo (filtered by 'photo' docName)
  useEffect(() => {

          const branchId = Number(localStorage.getItem("userId")) || 0;
     
    const fetchCustomerDetails = async () => { 
       try {
            const res = await fetch(
              `https://payyug.in/api/customers-get-userId?userId=${loan.customerId}&branchId=${branchId}`
            );

            const data = await res.json();
             console.log("Customer API Response:", data);
            setCustomerDetails(data.data);
          } catch (err) {
            console.error("Customer fetch error:", err);
          }
    };
    const fetchCustomerPhoto = async () => { 
      try {
        if (loan?.customerId && profile?.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`
          );
          const data = await res.json();
          if (res.ok && data.documents?.length > 0) {
            const photoDoc = data.documents.find(
              (doc) => doc.docName?.toLowerCase() === "photo"
            );
            if (photoDoc?.docImage) {
              setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
            }
          }
        }
      } catch (err) {
        console.error("Failed to fetch customer photo:", err);
      }
    };
    fetchCustomerDetails();
    fetchCustomerPhoto();
  }, [loan?.customerId, profile?.superAdminId, createdById]);

  

// const generatePDF = async () => {
//   const input = cardRef.current;
//   if (!input) return;

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const canvas = await html2canvas(input, {
//     scale: 2,
//     useCORS: true,
//     allowTaint: true,
//     scrollY: -window.scrollY,
//   });

//   const imgWidth = pageWidth - 20;      // 10mm left + 10mm right margin
//   const pageImageHeight = pageHeight - 20; // 10mm top + 10mm bottom margin

//   const totalImageHeight = (canvas.height * imgWidth) / canvas.width;

//   let renderedHeight = 0;

//   while (renderedHeight < totalImageHeight) {

//     // CREATE TEMPORARY CANVAS FOR EACH PAGE
//     const pageCanvas = document.createElement("canvas");
//     pageCanvas.width = canvas.width;
//     pageCanvas.height =
//       (pageImageHeight * canvas.width) / imgWidth;

//     const ctx = pageCanvas.getContext("2d");

//     // COPY PART OF FULL IMAGE → PAGE IMAGE
//     ctx.drawImage(
//       canvas,
//       0,
//       (renderedHeight * canvas.width) / imgWidth,
//       canvas.width,
//       pageCanvas.height,
//       0,
//       0,
//       canvas.width,
//       pageCanvas.height
//     );

//     const pageImgData = pageCanvas.toDataURL("image/png");
//     const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;

//     if (renderedHeight === 0) {
//       // FIRST PAGE
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     } else {
//       // OTHER PAGES
//       pdf.addPage();
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     }

//     renderedHeight += pageImageHeight;
//   }

//   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// };

const generatePDF = async () => {
  const input = cardRef.current;
  if (!input) return;

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  
  // Set margins (10mm is standard)
  const margin = 10;
  const contentWidth = pageWidth - (margin * 2);
  const contentHeight = pageHeight - (margin * 2);

  const canvas = await html2canvas(input, {
    scale: 2, // Keeps text sharp
    useCORS: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
  });

  const imgWidth = canvas.width;
  // Calculate how many pixels of the canvas fit into one PDF page
  const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;
  
  let heightLeft = canvas.height;
  let sY = 0; // Source Y position on the canvas

  while (heightLeft > 0) {
    // Determine the height of the slice for this page
    const sHeight = Math.min(heightLeft, pixelPageHeight);

    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = imgWidth;
    pageCanvas.height = sHeight;

    const ctx = pageCanvas.getContext("2d");
    ctx.drawImage(
      canvas,
      0, sY,         // Source X, Y
      imgWidth, sHeight, // Source Width, Height
      0, 0,          // Destination X, Y
      imgWidth, sHeight  // Destination Width, Height
    );

    const pageImgData = pageCanvas.toDataURL("image/jpeg", 1.0);
    
    // Calculate the display height in mm for the PDF
    const displayHeight_mm = (sHeight * contentWidth) / imgWidth;

    if (sY > 0) pdf.addPage();
    
    pdf.addImage(
      pageImgData, 
      "JPEG", 
      margin, 
      margin, 
      contentWidth, 
      displayHeight_mm
    );

    // Update trackers
    sY += sHeight;
    heightLeft -= sHeight;
  }

  pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
};

console.log("emis",emis)




  if (loanLoading || emiLoading)
    return <div className="branch-loan-card-container">Loading...</div>;
  if (loanError || emiError)
    return (
      <div className="branch-loan-card-container">{loanError || emiError}</div>
    );
  if (!loan)
    return (
      <div className="branch-loan-card-container">
        No loan found for Loan ID {loanId}
      </div>
    );

  return (
    <div>
      <div className="branch-loan-card-container" ref={cardRef}>
        {/* Header */}
        <header className="branch-loan-card-header">
          <div className="branch-loan-card-logo-box">
            {company?.logoUrl && (
              <img
                src={company.logoUrl}
                alt="Logo"
                className="branch-loan-card-logo"
              />
            )}
          </div>

          <div className="branch-loan-card-details-box">
            <h2>{company?.name || "Company Name"}</h2>
            <p>
              <strong>CIN:</strong> {company?.cin || "-"}
              <br />
             {/* <strong>Regt. Office:</strong>*/} {company?.address || "-"}
              {/* <b>Regt. Office:</b> {company?.ddress || "weriyfbup qcpqrhopwinhqguoq cwheruip chpefuib cuw hfwoeicf wperuoi hwe[cfio weuipfhwc[ rhwrfhewhfodhf jwoie rhfewoif ov "} */}
              <br />
              <strong>Website:</strong> {company?.domain || "-"}
              <br />
              <strong>Contact:</strong> {company?.contact || "-"}
              <br />
              <strong>Email:</strong> {company?.email || "-"}
            </p>
          </div>

          <div className="branch-loan-card-qr-box">
            <img
              // src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${loanId}`}
              src={company?.qrCodeUrl}
              alt="QR Code"
              className="branch-loan-card-qr"
            />
          </div>
          
        </header>

        {/* Title */}
        <div className="branch-loan-card-title-section">
          <div className="branch-loan-card-barcode-top">
            <Barcode
              value={loanId}
              height={40}
              displayValue={true}
              fontSize={14}
              margin={0}
            />
          </div>
          <h3 className="branch-loan-card-title">Loan EMI Card</h3>
        </div>

        {/* Loan & Customer Details */}
        <div className="branch-loan-card-loan-details">
          <table className="branch-loan-card-detail-table">
            <tbody>
              <tr>
                <td>
                  <strong>Customer Name:</strong> {loan.userName || "-"}
                </td>
                <td>
                  <strong>Loan ID:</strong>{" "}
                  {loan.loanAccountNumber || loan.loanNumber}
                </td>
                <td rowSpan="4" className="branch-loan-card-photo-cell">
                  <img
                    src={
                      photoUrl ||
                      "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                    }
                    alt="Customer"
                    className="branch-loan-card-photo"
                  />
                </td>
              </tr>
              {/* <tr>
                <td>
                  <strong>Contact No:</strong> {loan.contactNo || "-"}
                </td>
                <td>
                  <strong>Guardian Name:</strong> {loan.guardianName || "-"}
                </td>
              </tr> */}
              <tr>
                <td>
                  <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
                </td>
                <td>
                  <strong>Plan Name:</strong>{" "}
                  {loan.loanService || loan.loanService || "-"}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Number of EMI:</strong> {emis.length}
                </td>
                <td>
                  <strong>EMI Amount:</strong>{" "}
                  {formatAmount(emiAmountFromSchedule)}
                </td>
              </tr>
               <tr>
                <td colSpan={2}>
                  <strong>Address: </strong>{customerDetails?.address}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="branch-loan-card-branch-info">
            <p>
              <strong>Branch : </strong> {profile?.branchName || "-"}
            </p>
            <p>
              <strong>Date : </strong> {new Date().toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        {/* EMI Table */}
        <section className="branch-loan-card-table-section">
          <h4>EMI Schedule Terms</h4>
          <table className="branch-loan-card-table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Loan EMI Date</th>
                <th>Interest</th>
                <th>Principal</th>
                <th>EMI</th>
                <th>Receiving Date</th>
                <th>Received Amt</th>
                <th>Staff Sign</th>
                <th>Member Sign</th>
              </tr>
            </thead>
            <tbody>
              {emis.map((emi, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{formatDate(emi.dueDate)}</td>
                  <td>{formatAmount(emi.interestComponent)}</td>
                  <td>{formatAmount(emi.principalComponent)}</td>
                  <td>{formatAmount(emi.emiAmount)}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Footer */}
        <footer className="branch-loan-card-footer">
          <div>
            Member Signature
            <br />
            (सदस्य के हस्ताक्षर)
          </div>
          <div>
            Spouse Signature
            <br />
            (जीवनसाथी के हस्ताक्षर)
          </div>
        
          <div>
            Branch Seal With Signature
            <br />
            (शाखा मोहर के साथ हस्ताक्षर)
          </div>
        </footer>
      </div>

      {/* PDF Button */}
      <div style={{ textAlign: "center" }}>
        <button onClick={generatePDF} className="branch-loan-card-download-btn">
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};
export default LoanCard;
